import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

export const DealDetails = styled.div`
  min-width: 70%;
`;

export const Title = styled.div`
  border-top: 1px solid ${colors.rabbitGrey};
  font-size: 14px;
  line-height: 22px;
  padding-top: 5px;
  text-align: center;
`;

export const Information = styled.div`
  padding-bottom: 15px;
  text-align: center;

  i {
    margin: auto 5px;
  }
`;
